import React from 'react'

import { Route, Routes } from 'react-router-dom'
import Detail from './Detail'
import List from './List'
import SubmissionEditPage from '../Submission/EditDeal'
import EditDealSummaryPage from '../Submission/EditDealSummary'
import Shortlist from './Shortlist'
import PartnerProgram from './PartnerProgram'

const ProjectsV2: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:projectId" element={<Detail />} />
      <Route path="/:projectId/edit" element={<SubmissionEditPage />} />
      <Route
        path="/:projectId/edit-summary"
        element={<EditDealSummaryPage />}
      />
      <Route path="/:projectId/shortlist" element={<Shortlist />} />
      <Route path="/:projectId/partner-program" element={<PartnerProgram />} />
    </Routes>
  )
}

export default ProjectsV2
